export default "__VITE_ASSET__Dcuoj9v4__"